import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import React, { useContext, useEffect, useState } from "react";
import { menuContext } from "../../Context/menuContex";

export const OthersProductsCart = ({ item }) => {
  const { toShoppin, setToShoppin, saveToLocalStorage } =
    useContext(menuContext);

  const handdleChange = (e) => {
    if (e.target.checked) {
      const newItem = { ...item };
      setToShoppin([...toShoppin, newItem]);
    } else {
      setToShoppin(
        toShoppin.filter(
          (product) => product.adicionalsId !== item.adicionalsId
        )
      );
      saveToLocalStorage(toShoppin);
      console.log(1, toShoppin);
    }
  };

  return (
    <label className=" grid grid-flow-col grid-cols-[2fr_5fr_25px] gap-1  w-full min-w-[245px] border border-gray p-1 pt-0 rounded-xl drop-shadow-lg cursor-pointer">
      <figure className=" max-w-[150px] min-w-[55px] flex rounded-xl place-self-center p-1	">
        <img
          loading="lazy"
          className=" place-self-center object-contain rounded-xl  "
          src={item.images.small}
          alt={item.name}
        />
      </figure>
      <span className=" flex flex-col self-center">
        <h2 className=" font-bold text-base  text-start mr-2 pl-2">
          {item.name}
        </h2>
        <p className="font-semibold text-xs mr-2 absolute bottom-1 pl-2">
          {item.tamaño ? item.tamaño : null}
        </p>
        <p className="font-semibold place-self-end text-sm mr-2">
          ${item.price.toLocaleString(undefined, { minimumFractionDigits: 0 })}
        </p>
      </span>

      <input
        className="w-[20px] h-[20px] self-center cursor-pointer"
        type="checkbox"
        name={item.name}
        id={item.id}
        onChange={(e) => handdleChange(e)}
      />
    </label>
  );
};
